
export default function FinalCTA() {
  return (
    <section className="py-24 bg-[#2B2B2B]">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <h2 className="text-5xl font-bold text-white mb-6 font-serif">
          Ready to Start?
        </h2>

        <p className="text-xl text-gray-400 mb-10">
          Get your custom training today!
        </p>

        <a
          href="https://calendar.app.google/fm26XKpqmgC8oisS7"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-3 px-10 py-5 bg-[#E8744F] text-white text-lg font-semibold rounded-full hover:bg-[#d66640] transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
        >
          Get Started — Book a Free 30-minute Consult!
          <i className="ri-arrow-right-line text-xl"></i>
        </a>
      </div>

      <footer className="mt-24 pt-12 border-t border-gray-700">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6">
            <div className="flex items-center gap-3">
              <img
                src="https://static.readdy.ai/image/5e5e0a5518213db53ed2e7d68521f761/62cb70853685ca02083f2cf2f9848005.jpeg"
                alt="PACED Coaching"
                className="h-10 w-10 object-cover rounded-full"
              />
              <span className="text-white font-bold text-lg">PACED Coaching</span>
            </div>

            <div className="flex items-center gap-4">
              <a
                href="https://www.facebook.com/profile.php?id=61587706061854&rdid=0qexBJhoWpMNg9rp&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F17GLJU7ngf%2F#"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-[#1877F2] transition-colors cursor-pointer"
              >
                <i className="ri-facebook-fill text-white text-lg"></i>
              </a>
              <a
                href="https://www.instagram.com/pacedcoaching/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-[#E1306C] transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-white text-lg"></i>
              </a>
            </div>

            <div className="text-gray-400 text-sm">
              © 2025 PACED Coaching. All rights reserved. • <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors cursor-pointer"></a>
            </div>
          </div>
        </div>
      </footer>
    </section>
  );
}
